"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var localized_strings_1 = require("localized-strings");
exports.powerUnits = new localized_strings_1.default({
    en: {
        Btu: {
            AbbreviatedDisplay: 'btu',
            FullDisplay: 'BTUs per hour'
        },
        Horsepower: {
            AbbreviatedDisplay: 'hp',
            FullDisplay: 'horsepower'
        },
        Kilowatt: {
            AbbreviatedDisplay: 'kW',
            FullDisplay: 'kilowatts'
        },
        Watt: {
            AbbreviatedDisplay: 'W',
            FullDisplay: 'watts'
        }
    }
}, {
    logsEnabled: false
});
